import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary/90 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm md:text-base">
              <Icon name="Award" size={20} />
              <span>880+ Projects Delivered | 678+ Organizations Served</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
              Comprehensive Business Solutions Under One Roof
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed">
              Transform your business with our integrated ecosystem of HR Solutions, Global Trade Operations, and Engineering Services. Precision in Partnership, Excellence in Execution.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="px-6 md:px-8 py-3 md:py-4 bg-accent hover:bg-accent/90 text-white rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base">
                <Icon name="Calendar" size={20} />
                Schedule Consultation
              </button>
              <button className="px-6 md:px-8 py-3 md:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base">
                <Icon name="Download" size={20} />
                Download Brochure
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 md:gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 space-y-2 md:space-y-3">
              <Icon name="Users" size={32} className="text-accent" />
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold">880+</div>
              <div className="text-sm md:text-base text-white/80">Projects Completed</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 space-y-2 md:space-y-3 mt-6 md:mt-8">
              <Icon name="Building2" size={32} className="text-accent" />
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold">678+</div>
              <div className="text-sm md:text-base text-white/80">Organizations</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 space-y-2 md:space-y-3 -mt-6 md:-mt-8">
              <Icon name="Trophy" size={32} className="text-accent" />
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold">112</div>
              <div className="text-sm md:text-base text-white/80">Industry Awards</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 space-y-2 md:space-y-3">
              <Icon name="Globe" size={32} className="text-accent" />
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold">25+</div>
              <div className="text-sm md:text-base text-white/80">Countries Served</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;